/*
 * PblManagement Reducer
 * Description
 * The reducer takes care of our data. Using actions, we can
 * update our application state. To add a new action,
 * add it to the switch statement in the reducer function
 *
 * @version 1.0.0
 * @author Davide Polci
 * @since 30-Jun-2025
 */

import produce from 'immer'
import { actionTypes } from '../actions/pblManagement'

const ACTION_HANDLERS = {
  [actionTypes.GET_PBLS_REQUEST]: produce((draft) => {
    draft.pblsList = null
    draft.pagination = initialState.pagination
  }),
  [actionTypes.GET_PBLS_SUCCESS]: produce((draft, action) => {
    draft.pblsList = action?.payload?.paybylinks || []
    draft.pagination = action.payload?.pagination || initialState.pagination
  }),
  [actionTypes.GET_PBLS_FAILURE]: produce((draft) => {
    draft.pblsList = []
    draft.pagination = initialState.pagination
  }),
  [actionTypes.GET_PBL_DETAILS_SUCCESS]: produce((draft, action) => {
    draft.pblDetail = action.payload
  }),
  [actionTypes.GET_PBL_DETAILS_FAILURE]: produce((draft) => {
    draft.pblDetail = null
  }),

  [actionTypes.DO_RESEND_LINK]: produce((draft, action) => {
    const { payload } = action
    const {
      currency,
      orderId,
      cardHolderEmail,
      /** language, */ link,
      amount,
      expirationDateTime,
      donation,
      linkId,
      amountType,
      minAmount,
      maxAmount,
      terminalId,
      predefinedAmounts,
      paymentDesc
    } = payload
    draft.generatePBLSendLinkResult = {
      currency: currency,
      orderId: orderId,
      cardHolderEmail: cardHolderEmail,
      donation: donation,
      terminalId: terminalId,
      minAmount,
      maxAmount,
      predefinedAmounts,
      paymentDesc,
      // language: language,
      isPblManagement: true,
      amountTypeValue: amountType,
      paymentLink: {
        link: link,
        linkId: linkId,
        amount: amount,
        expirationDate: expirationDateTime
      }
    }
  }),
  [actionTypes.DO_SET_PBL_SOURCE_PAGE]: produce((draft, action) => {
    draft.pblSourcePage = action.payload
  }),
  [actionTypes.GET_PBL_VERSION_SETTINGS_REQUEST]: produce((draft) => {
    draft.flagPblV3 = null
  }),
  [actionTypes.GET_PBL_VERSION_SETTINGS_SUCCESS]: produce((draft, action) => {
    draft.flagPblV3 = action?.response?.featureFlags?.length > 0 || false
  }),
  [actionTypes.GET_PBL_VERSION_SETTINGS_FAILURE]: produce((draft) => {
    draft.flagPblV3 = null
  })
  // @generator reducer:type:action
}

// The initial state of the pblManagement
const initialState = {
  pblsList: null,
  pblDetail: null,
  generatePBLSendLinkResult: null,
  pblSourcePage: '',
  pagination: {
    total: 0,
    page: 1,
    pageSize: 10,
    pageCount: 1
  },
  flagPblV3: null
}

const pblManagement = (state = initialState, action) => {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export default pblManagement
